import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { GendersFailure, GendersRequest, GendersSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'genders';

export interface State {
  data: ParameterResult[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(GendersFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(GendersRequest, state => ({ ...state, error: null, loading: true })),
    on(GendersSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
